import { GetterTree } from 'vuex';
import { RootState } from '../../types';
import { IFloorplanViewState, IFloorplanButton, IFloorplanButtonWithRelay } from './types';
import { IRelay } from '../relaysView/types';

export const getters: GetterTree<IFloorplanViewState, RootState> = {
    buttons(state, gettersLocal, rootState, rootGetters):
    (deviceNumber: string) => IFloorplanButtonWithRelay[] {
        return (deviceNumber: string) => {
            const result: IFloorplanButtonWithRelay[] = [];

            const relays = rootGetters['relaysView/relaysAsDic'](deviceNumber) as { [no: number]: IRelay } || {};
            const floorplan = state.devices[deviceNumber];
            if (floorplan && relays && floorplan.buttons) {
                for (const button of floorplan.buttons) {
                    const relayNumber = parseInt(button.relayNumber, 10);
                    if (relays[relayNumber]) {
                        result.push({
                            relay: relays[relayNumber],
                            button,
                        });
                    }
                }
            }
            return result;
        };
    },
};
